<details class="pdw-more" aria-label="Published workflow">
  <summary class="pdw-more__summary pdw-more__summary--disclosure">
    Published workflow
    <span class="pdw-panel__hint">Version {{ graph().version }} &middot; {{ graph().contentHash }} &middot; this case is pinned to it</span>
  </summary>
  <div class="pdw-more__body">
    <div class="pdw-graph-legend" aria-hidden="true">
      <span class="pdw-graph-legend__key pdw-graph-legend__key--done">Done</span>
      <span class="pdw-graph-legend__key pdw-graph-legend__key--current">Current</span>
      <span class="pdw-graph-legend__key pdw-graph-legend__key--pending">Pending</span>
      <span class="pdw-graph-legend__key pdw-graph-legend__key--skipped">Not reached</span>
    </div>
    <ol class="pdw-graph" aria-label="Published workflow steps">
      @for (node of nodes(); track node.id; let last = $last) {
        <li [class.pdw-node--done]="node.status === 'done'" [class.pdw-node--current]="node.status === 'active'"
          [class.pdw-node--pending]="node.status === 'upcoming'" [class.pdw-node--skipped]="node.status === 'skipped'"
          [attr.aria-current]="node.status === 'active' ? 'step' : null" class="pdw-node">
          <div class="pdw-node__box">
            <div class="pdw-node__head">
              <span class="pdw-node__title">{{ node.title }}</span>
              <span class="pdw-node__kind">{{ labelFor(node.kind) }}</span>
            </div>
            <p class="pdw-node__meta">
              @if (node.role) { {{ roleLabel(node.role) }} &middot; }{{ statusLabels[node.status] }}
            </p>
            @if (node.kind === 'for-each' && actions().length) {
              <ol class="pdw-node__items">
                @for (action of actions(); track action.id) {
                  <li class="pdw-node__item">
                    <span class="pdw-status pdw-status--{{ action.status }}">{{ action.statusLabel }}</span>
                    <span>{{ action.description }}</span>
                    <span class="pdw-node__item-role">{{ action.role }}</span>
                  </li>
                }
              </ol>
            }
            @if (node.outcomes.length || node.canReturn) {
              <ul class="pdw-node__edges" aria-label="Outcomes">
                @for (edge of graph().edges; track $index) {
                  @if (edge.from === node.id) {
                    <li>
                      <span class="pdw-node__outcome">{{ labelFor(edge.outcome) }}</span>
                      <span aria-hidden="true">&rarr;</span>
                      {{ titles().get(edge.to) ?? labelFor(edge.to) }}
                      @if (edge.route === 'prior-owner') { <span class="pdw-node__note">(prior owner)</span> }
                    </li>
                  }
                }
              </ul>
            }
          </div>
          @if (!last) { <span class="pdw-node__connector" aria-hidden="true"></span> }
        </li>
      }
    </ol>
  </div>
</details>